/**
 * Styled components for Picker.
 * Import from here — never define styled() inside Picker.js.
 */
import React from 'react';
import { styled } from '@mui/system';
import { Button, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Slide from '@mui/material/Slide';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';

// ── Animation ────────────────────────────────────────────────────────────────

export const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// ── Layout ───────────────────────────────────────────────────────────────────

export const Container = styled(Grid)(({ theme }) => ({
    padding: '20px 30px 0',
    width: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
        alignContent: 'center',
        flexDirection: 'column',
        padding: '30px 0 0',
    },
}));

export const Subcontainer = styled(Grid)({
    marginBottom: '40px',
    '& .MuiPickersBasePicker-container': {
        alignItems: 'center',
    },
});

export const Language = styled(Subcontainer)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '20px 30px 0',
    '.MuiInput-input': {
        width: '50px',
        fontSize: '20px',
    },
    [theme.breakpoints.down('md')]: {
        padding: '30px 0 0',
        maxWidth: '83.333333%',
        margin: 'auto',
    },
}));

export const GoBack = styled('div')({
    backgroundColor: '#e5e8eb',
    padding: '10px 40px',
});

export const GoBackLink = styled('p')({
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
});

// ── Form inputs ──────────────────────────────────────────────────────────────

export const Form = styled(FormControl)({
    minWidth: '220px',
    marginBottom: '15px',
    marginTop: '10px',
});

export const SummaryTimePicker = styled(Form)(({ width }) => ({
    minWidth: width,
}));

export const TimeSelect = styled(Select)({
    '.MuiSelect-icon': {
        display: props => (props.disabled ? 'none' : ''),
    },
});

export const Input = styled(TextField)({
    margin: '10px',
    width: '95%',
});

export const InputContainer = styled('form')({
    width: '100%',
});

// ── Calendar ─────────────────────────────────────────────────────────────────

export const Calendar = styled(StaticDatePicker)({
    '& .MuiPickersCalendarHeader-switchHeader': {
        display: 'none',
    },
    '& .MuiDialogActions-root': {
        display: 'none',
    },
    '& .MuiPickersToolbar-root': {
        display: 'none',
    },
    alignItems: 'center',
});

// ── Summary panel ────────────────────────────────────────────────────────────

export const Summary = styled(Paper)(({ theme }) => ({
    padding: '10px 30px',
    [theme.breakpoints.down('sm')]: {
        padding: '10px',
        '& .MuiTypography-body1': {
            fontSize: '0.8em',
        },
    },
}));

export const SummaryTimes = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
    width: '100%',
    '& .MuiFormControl-root': {
        [theme.breakpoints.down('sm')]: {
            width: '45%',
        },
    },
}));

export const TimeIcon = styled(AccessTimeIcon)({
    width: '45px',
    height: 'auto',
    '@media (max-width: 600px)': {
        display: 'none',
    },
});

// ── Pricing ──────────────────────────────────────────────────────────────────

export const Prices = styled(Paper)({
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '10px 0px',
    width: '100%',
});

export const Contact = styled(Prices)({
    alignItems: 'center',
    padding: '5px',
    marginBottom: '15px',
});

export const Price = styled(Typography)({
    textAlign: 'left',
});

export const PriceSet = styled(Grid)(({ theme }) => ({
    padding: '0 30px',
    [theme.breakpoints.down('sm')]: {
        padding: '0 10px',
    },
}));

// ── Typography variants ──────────────────────────────────────────────────────

export const Subtitle = styled(Typography)({
    margin: '10px',
    width: '95%',
});

export const Found = styled(Typography)({
    color: 'green',
    textAlign: 'center',
});

export const NotFoundTitle = styled(Typography)({
    marginBottom: '1em',
});

export const NotFoundSubtitle = styled(Typography)({
    marginBottom: '3em',
});

export const DiscrepancyText = styled(Typography)({
    color: 'orange',
});

export const FieldSubtitle = styled(Typography)({
    color: 'gray',
});

// ── Buttons ──────────────────────────────────────────────────────────────────

export const Book = styled(Button)({
    margin: '15px 0 10px',
    backgroundColor: 'green',
    color: 'white',
    '&:hover': {
        backgroundColor: '#006500',
    },
});
